module.exports = __webpack_public_path__ + "img/CC-Logo.61c043de.png";